<template>
  <CContainer
    class="d-flex bg-custom align-items-center justify-content-center min-vw-100 min-vh-100"
  >
    <CRow class="width-custom justify-content-center">
      <CCol md="12" lg="12">
        <CCard class="p-4 color-custom">
          <CCardBody>
            <CForm class="d-flex flex-column justify-content-center">
              <div class="mb-2 border-custom align-self-center">
                <CImg
                  :src="image"
                  align="center"
                  width="120"
                  height="120"
                  class="m-0"
                />
              </div>
              <h2 class="text-center">Iniciar sesión</h2>

              <CAlert v-show="error" color="danger">{{ error }}</CAlert>
              <CInput
                :value.sync="claveEmpresa"
                class="mt-3 text-lowercase"
                placeholder="Código de empresa"
                autocomplete="company"
              >
                <template #prepend-content>
                  <CIcon name="cil-industry" />
                </template>
              </CInput>
              <CInput
                :value.sync="email"
                type="email"
                placeholder="Correo electrónico"
                autocomplete="username email"
              >
                <template #prepend-content>
                  <CIcon name="cil-user" />
                </template>
              </CInput>
              <CInput
                :value.sync="contrasena"
                class="mb-0"
                placeholder="Contraseña"
                type="password"
                autocomplete="curent-password"
              >
                <template #prepend-content>
                  <CIcon name="cil-lock-locked" />
                </template>
              </CInput>
              <CRow>
                <CCol col="12" class="text-left">
                  <router-link
                    class="btn-custom-width"
                    :to="{ name: 'Recovery' }"
                  >
                    <CButton color="link" class="px-0 link-underline"
                      >Recuperar contraseña</CButton
                    >
                  </router-link>
                </CCol>
              </CRow>
              <div
                v-if="isLoading"
                class="w-100 d-flex justify-content-center align-items-center"
              >
                <div class="sk-flow d-flex align-items-center">
                  <div class="sk-flow-dot bg-primary"></div>
                  <div class="sk-flow-dot bg-primary"></div>
                  <div class="sk-flow-dot bg-primary"></div>
                </div>
              </div>
              <CRow class="px-3 mt-3" alignHorizontal="center">
                <!-- <router-link class="btn-custom-width" :to="{ name: 'Home' }"> -->
                <CButton
                  @click.prevent="setClave()"
                  type="submit"
                  class="btn-custom-width text-center"
                  color="primary"
                >
                  <!-- <div
                    v-if="isLoading"
                    class="w-100 d-flex justify-content-center align-items-center"
                  >
                    <div class="sk-flow d-flex align-items-center width-custom-load">
                      <div class="sk-flow-dot bg-secondary"></div>
                      <div class="sk-flow-dot bg-secondary"></div>
                      <div class="sk-flow-dot bg-secondary"></div>
                    </div>
                  </div>-->
                  Acceder
                </CButton>
                <!-- </router-link> -->
              </CRow>
            </CForm>
          </CCardBody>
        </CCard>
        <p class="text-white m-0 text-center">Hooch v{{ version }}</p>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
import logo from "../assets/images/Logo-Vertical-Blanco.png";
// import { mapState } from "vuex";

// import { validationMixin } from "vuelidate";
// import { required, email } from "vuelidate/lib/validators";

const { version } = require('../../package.json');

export default {
  name: "Login",
  data() {
    return {
      image: logo,
      claveEmpresa: "",
      email: "",
      contrasena: "",
      isLoading: false,
      error: ""
    };
  },

  // mixins: [validationMixin],
  // validations: {
  //   claveEmpresa: {
  //     required
  //   },
  //   email: {
  //     required,
  //     email
  //   }
  // },

  methods: {
    setClave() {
      // this.validateInicio();

      // if (this.isValidClave && this.isValidEmail) {
      this.isLoading = true;
      this.$store.commit("SET_CLAVEEMPRESA", {
        clave_empresa: this.claveEmpresa
      });

      this.$store
        .dispatch("login", {
          claveEmpresa: this.claveEmpresa.toLowerCase(),
          email: this.email.toLowerCase(),
          password: this.contrasena
        })
        .then(() => {
          this.isLoading = false;
        })
        .catch(rej => {
          this.isLoading = false;
          // console.log(rej);
          if (rej) {
            rej.data.code == "klay.actions.usuarios.obtener_apikey.usuario:fail"
              ? (this.error = "El campo correo electrónico es incorrecto.")
              : (this.error = rej.data.message);
          } else {
            this.error = "El campo de código de empresa es incorrecto.";
          }
        });
      // }
    }
    // checkIfValid(fieldName) {
    //   const field = this.$v[fieldName];
    //   if (!field.$dirty) {
    //     return null;
    //   }
    //   return !(field.$invalid || field.$model === "");
    // },
    // validateInicio() {
    //   this.$v.claveEmpresa.$touch();
    //   this.$v.email.$touch();
    // }
  },

  computed: {
  //   isValidClave() {
  //     return !this.$v.claveEmpresa.$invalid;
  //   },
  //   isValidEmail() {
  //     return !this.$v.email.$invalid;
  //   }
      version() {
        return version
      }
  }
};
</script>
<style src="spinkit/spinkit.min.css"></style>
<style scoped>
.bg-custom {
  background-color: #3c4b64 !important;
  margin: 0 !important;
}
.color-custom {
  background-color: rgba(255, 255, 255, 1);
}
.border-custom {
  border-radius: 50% !important;
  background-color: #3c4b64 !important;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 160px;
  width: 160px;
}

.width-custom-load {
  height: 19px;
  /* width: 100%; */
}
.width-custom {
  width: 450px;
}
.btn-custom-width {
  width: 100%;
}
.link-underline {
  text-decoration: underline;
}
.text-lowercase input {
  text-transform: lowercase;
}
</style>
